import * as fromSites from '../reducers/sites';
import * as fromUsers from '../reducers/users';
import * as fromGeneral from '../reducers/general';
import * as fromElements from '../reducers/elements';

export { fromSites as sites };

//TODO: all selectors should be moved to belonging files
export const getAuthInfo = (state) => fromUsers.getAuthInfo(state.users);
export const getAuthUser = (state) => fromUsers.getAuthUser(state.users);
export const getIsAdmin = (state) => {
    const auth = getAuthUser(state);
    return auth && auth.roles ? auth.roles.includes('ADMIN') : false;
};
export const getIsLoggedIn = (state) => fromUsers.getIsLoggedIn(state.users);
export const getAccessToken = (state) => fromUsers.getAccessToken(state.users);
export const getLoginError = (state) => fromUsers.getLoginError(state.users);
export const getLoginSuccess = (state) =>
    fromUsers.getLoginSuccess(state.users);
export const getErrorMessage = (state) =>
    fromUsers.getErrorMessage(state.users);
export const getSuccessMessage = (state) =>
    fromUsers.getSuccessMessage(state.users);
export const getAuthError = (state) => fromUsers.getAuthError(state.users);
export const getAuthSuccess = (state) => fromUsers.getAuthSuccess(state.users);
export const getIsFetching = (state) => fromUsers.getIsFetching(state.users);

// Sites
export const getSite = (state, id) => fromSites.getSite(state.sites, id);
export const getSites = (state) => fromSites.getSites(state.sites);
export const getIsLoading = (state) => fromSites.getIsLoading(state.sites);
export const getIsSavedSite = (state) => fromSites.getIsSavedSite(state.sites);
export const getSiteById = (id) => (state) =>
    fromSites.getSite(state.sites, id);

export const getSiteMutationError = (state) =>
    fromSites.getSiteMutationError(state.sites);
export const getSiteMutationSuccess = (state) =>
    fromSites.getSiteMutationSuccess(state.sites);

export const getCountries = (state) => fromGeneral.getCountries(state.general);

// Templates
export const getTemplates = (state) => fromGeneral.getTemplates(state.general);
export const getTemplate = (state, id) =>
    fromGeneral.getTemplate(state.general, id);

export const getConfig = (state) => state.config;

// Select elements
export const getVisibleElements = (state, listKey) =>
    fromElements.getVisibleElements(state.elements, listKey);
export const getIsFetchingElements = (state, listKey) =>
    fromElements.getIsFetchingElements(state.elements, listKey);

// Admin
// Users
export const getAllUsers = (state) => fromUsers.getAllUsers(state.users);
